'use client';

import { useConnection } from "wagmi";
import { useDisclosure } from "@heroui/react";
import { useEffect, useState } from "react";
import type { FarmConfig, MasterChefConfig } from "@/constants/project-specific/farms/types";
import IconButton from "@/components/Buttons/IconButton";
import dynamic from "next/dynamic";

// const userBatchSettings = atomWithStorage('batchSettings', batchSettings)

interface ApyButtonProps {
  masterChef: MasterChefConfig;
  farm: FarmConfig;
}
export default function ApyButton({
  farm,
  masterChef
}: ApyButtonProps) {
  const {
    isOpen,
    onOpenChange
  } = useDisclosure();
  const RoiModal = dynamic(() => import('./RoiModal'), {
    ssr: false
  });
  const [currentStep, setCurrentStep] = useState(0);
  const {
    address,
    chainId,
    connector
  } = useConnection();

  // const [batchSettings, setBatchSettings] = useAtom(userBatchSettings);

  useEffect(() => {}, [isOpen]);
  return <>
      {isOpen && <RoiModal isOpen={isOpen} onOpenChange={onOpenChange} farm={farm} masterChef={masterChef} />}
      <IconButton icon="material-symbols:calculate-outline" />
    </>;
}